<template>
  <!-- Sacamos TODO el modal al body -->
  <teleport to="body">
    <div class="mfcu-overlay" @click.self="handleClose">
      <div class="mfcu-dialog">
        <button
          type="button"
          class="mfcu-close"
          @click="handleClose"
        >
          ✕
        </button>

        <h2 class="mfcu-title">Filtrar por categoría</h2>
        <p class="mfcu-subtitle">
          Selecciona una o varias categorías para acotar las relaciones visibles.
        </p>

        <!-- Buscador -->
        <div class="mfcu-search">
          <input
            v-model="busqueda"
            type="text"
            class="mfcu-search-input"
            placeholder="Buscar categoría..."
          />
        </div>

        <!-- Chips de categorías -->
        <div class="mfcu-chips">
          <button
            v-for="cat in categoriasFiltradas"
            :key="cat"
            type="button"
            @click="toggleCategoria(cat)"
            :class="[
              'mfcu-chip',
              seleccionadas.includes(cat) ? 'is-active' : 'is-inactive'
            ]"
          >
            {{ cat }}
          </button>

          <p
            v-if="categoriasFiltradas.length === 0"
            class="mfcu-empty"
          >
            No se encontraron categorías con ese filtro.
          </p>
        </div>

        <!-- Footer -->
        <div class="mfcu-footer">
          <button
            type="button"
            class="mfcu-btn mfcu-btn--ghost"
            @click="handleClose"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="mfcu-btn mfcu-btn--primary"
            @click="aplicar"
          >
            Aplicar filtros
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'ModalFiltroCategorias',
  props: {
    categorias: {
      type: Array,
      default: () => [],
    },
    valorInicial: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      seleccionadas: [...(this.valorInicial || [])],
      busqueda: '',
    };
  },
  computed: {
    categoriasFiltradas() {
      if (!this.busqueda.trim()) return this.categorias || [];
      const t = this.busqueda.toLowerCase();
      return (this.categorias || []).filter((cat) =>
        String(cat).toLowerCase().includes(t)
      );
    },
  },
  methods: {
    toggleCategoria(cat) {
      const idx = this.seleccionadas.indexOf(cat);
      if (idx > -1) {
        this.seleccionadas.splice(idx, 1);
      } else {
        this.seleccionadas.push(cat);
      }
    },
    aplicar() {
      this.$emit('aplicar', this.seleccionadas);
      this.$emit('cerrar');
    },
    handleClose() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style scoped>
.mfcu-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(15, 23, 42, 0.55),
      rgba(15, 23, 42, 0.94)
    );
  backdrop-filter: blur(18px);
}

.mfcu-dialog {
  position: relative;
  width: 100%;
  max-width: 480px;
  max-height: 80vh;
  border-radius: 1.5rem;
  padding: 1.4rem 1.3rem 1.1rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.32),
      rgba(15, 23, 42, 0.96)
    );
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow:
    0 20px 50px rgba(15, 23, 42, 0.98),
    0 0 0 1px rgba(15, 23, 42, 0.9);
  color: #e5e7eb;
  overflow-y: auto;
}

/* Scrollbar elegante */
.mfcu-dialog::-webkit-scrollbar {
  width: 6px;
}
.mfcu-dialog::-webkit-scrollbar-track {
  background: transparent;
}
.mfcu-dialog::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 999px;
}

.mfcu-close {
  position: absolute;
  top: 0.6rem;
  right: 0.7rem;
  border: none;
  background: transparent;
  color: #cbd5f5;
  cursor: pointer;
  font-size: 0.9rem;
}

.mfcu-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.15rem;
}

.mfcu-subtitle {
  font-size: 0.8rem;
  color: #9ca3af;
  margin-bottom: 0.75rem;
}

.mfcu-search {
  margin-bottom: 0.65rem;
}

.mfcu-search-input {
  width: 100%;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.9);
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  color: #e5e7eb;
  outline: none;
}

.mfcu-search-input::placeholder {
  color: #64748b;
}

/* Contenedor de chips */
.mfcu-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 0.1rem;
  margin-bottom: 0.9rem;
}

.mfcu-chips::-webkit-scrollbar {
  width: 5px;
}
.mfcu-chips::-webkit-scrollbar-track {
  background: transparent;
}
.mfcu-chips::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 999px;
}

.mfcu-chip {
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.75rem;
  padding: 0.25rem 0.65rem;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease;
  white-space: nowrap;
}

.mfcu-chip.is-active {
  background: rgba(37, 99, 235, 0.95);
  border-color: rgba(59, 130, 246, 1);
  color: #eff6ff;
}

.mfcu-chip.is-inactive {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.6);
  color: #e5e7eb;
}

.mfcu-chip.is-inactive:hover {
  background: rgba(15, 23, 42, 1);
}

.mfcu-empty {
  font-size: 0.78rem;
  color: #9ca3af;
  margin-top: 0.25rem;
}

.mfcu-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.4rem;
  margin-top: 0.1rem;
}

.mfcu-btn {
  border-radius: 999px;
  font-size: 0.8rem;
  padding: 0.4rem 0.9rem;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease;
}

.mfcu-btn--ghost {
  background: rgba(15, 23, 42, 0.4);
  border-color: rgba(148, 163, 184, 0.6);
  color: #e5e7eb;
}

.mfcu-btn--ghost:hover {
  background: rgba(15, 23, 42, 0.7);
}

.mfcu-btn--primary {
  background: rgba(37, 99, 235, 0.96);
  border-color: rgba(59, 130, 246, 1);
  color: #eff6ff;
}

.mfcu-btn--primary:hover {
  background: rgba(37, 99, 235, 1);
}
</style>
